import SupportAgent from '@mui/icons-material/SupportAgent';
import { Button } from '@mui/material';
import { useCallback, useState } from 'react';
import JourneySupportDrawer from './JourneySupportDrawer';

type JourneyHelpButtonProps = {
  appId: string;
};

/**
 * Botão "Ajuda" do header que abre o drawer do canal de atendimento
 * (`JourneySupportDrawer`, que resolve a URL via `GET /v2/supportSector`).
 */
export default function JourneyHelpButton({ appId }: JourneyHelpButtonProps) {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);

  return (
    <>
      <Button
        aria-label="Ajuda"
        color="inherit"
        data-app-id={appId}
        onClick={handleOpen}
        startIcon={<SupportAgent />}
        sx={{ color: 'primary.contrastText', minWidth: 'auto', px: 1 }}
      >
        Ajuda
      </Button>
      <JourneySupportDrawer appId={`${appId}-drawer`} onClose={handleClose} open={open} />
    </>
  );
}
